import React from 'react';
import {
    Box,
    Container,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';

const ProjectsPage = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <Box
            sx={{
                minHeight: '100vh',
                backgroundColor: theme.palette.background.main,
                display: 'flex',
                alignItems: isMobile ? 'flex-start' : 'center',
                justifyContent: 'center',
                pt: isMobile ? 24 : 8 // Account for fixed AppBar
            }}
        >
            <Container maxWidth="md">
                <Typography
                    variant="h1"
                    align="center"
                    sx={{
                        fontFamily: '"Nexa Slab Regular", serif',
                        // letterSpacing: 4,
                        textTransform: 'uppercase',
                        fontWeight: 700,
                        fontSize: { xs: '3rem', md: '5rem' },
                        mb: 4,
                        color: 'white'
                    }}
                >
                    Coming Soon
                </Typography>

                <Typography
                    variant="h4"
                    align="center"
                    sx={{
                        color: 'primary.main',
                        fontWeight: 300
                    }}
                >
                    Our projects portfolio is under construction
                </Typography>
            </Container>
        </Box>
    );
};

export default ProjectsPage; 